export enum EPlayGroundRoutes {
  PLAYGROUND = 'playground'
}
